import { render } from "./voidModal.vue?vue&type=template&id=6cad96f6"
import script from "./voidModal.vue?vue&type=script&lang=js"
export * from "./voidModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__